import type { VeterinarianOfficeUser } from '@/models/DTO/veterinarian-office-user/veterinarian-office-user.model'
import type { VeterinarianOfficeUserUpdateRequest } from '@/models/DTO/veterinarian-office-user/veterinarian-office-user-update-request.model'
import { BaseAPIService } from './base-api.service'

const API_VERSION: string = import.meta.env.VITE_API_VERSION
const VET_OFFICE_USERS_URL = `/api/v${API_VERSION}/VeterinarianOfficeUsers`
const VET_OFFICE_USER_BY_ID_URL = `${VET_OFFICE_USERS_URL}/:id`
const LOCKOUT_USER_URL = `${VET_OFFICE_USERS_URL}/LockOutVeterinarianOfficeUsers/:id`
const UNLOCK_USER_URL = `${VET_OFFICE_USERS_URL}/UnlockVeterinarianOfficeUsers/:id`

export interface IVeterinarianOfficeUserService {
  getById(id: string): Promise<VeterinarianOfficeUser>
  update(model: VeterinarianOfficeUserUpdateRequest): Promise<VeterinarianOfficeUser>
  lockoutUser(id: string): Promise<void>
  unlockUser(id: string): Promise<void>
}

export class VeterinarianOfficeUserService implements IVeterinarianOfficeUserService {
  private readonly _baseAPIService: BaseAPIService

  constructor() {
    this._baseAPIService = new BaseAPIService()
  }

  public async getById(id: string): Promise<VeterinarianOfficeUser> {
    const resp = await this._baseAPIService.client.get<VeterinarianOfficeUser>(
      VET_OFFICE_USER_BY_ID_URL.replace(':id', id),
    )
    return resp.data
  }

  public async update(model: VeterinarianOfficeUserUpdateRequest): Promise<VeterinarianOfficeUser> {
    const resp = await this._baseAPIService.client.put<VeterinarianOfficeUser>(
      VET_OFFICE_USER_BY_ID_URL.replace(':id', model.id),
      model,
    )
    return resp.data
  }

  public async lockoutUser(id: string): Promise<void> {
    await this._baseAPIService.client.post(LOCKOUT_USER_URL.replace(':id', id))
  }

  public async unlockUser(id: string): Promise<void> {
    await this._baseAPIService.client.post(UNLOCK_USER_URL.replace(':id', id))
  }
}
